module.exports = __webpack_public_path__ + "static/media/blog1_2.8e57b406.webp";